module.exports = __webpack_public_path__ + "static/media/piper-nuding-paw-2-background.739673e5.svg";